export class RabiesVaccineModel {
    vaccine_manuf: string
    vaccine_type: string
    vaccine_expire: string
    vaccine_name: string
    vaccine_active: boolean
    vaccine_use: string 
 
    constructor(
        vaccine_manuf: string,
        vaccine_type: string,
        vaccine_expire: string,
        vaccine_name: string,
        vaccine_active: boolean,
        vaccine_use: string 
    ) {
        this.vaccine_manuf = vaccine_manuf
        this.vaccine_type = vaccine_type
        this.vaccine_expire = vaccine_expire
        this.vaccine_name = vaccine_name
        this.vaccine_active = vaccine_active
        this.vaccine_use = vaccine_use
    }
}